module.exports = __webpack_public_path__ + "media/bpen à-rai gan.7b8716df.mp3";